// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Definition, DefinitionT, verifyDefinition } from "./definition";
import { OffsetType, OffsetTypeT, verifyOffsetType } from "./offset-type";
import { RegisterType } from "./register-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Offset register configuration — maps a byte position to a named
 * register within a data block.
 */
export class Offset implements flatbuffers.IUnpackableObject<OffsetT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Offset {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOffset(bb: flatbuffers.ByteBuffer, obj?: Offset): Offset {
    return (obj || new Offset()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsOffset(bb: flatbuffers.ByteBuffer, obj?: Offset): Offset {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Offset()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  dataBlockId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  offsetTypeId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  initialValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  lastValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  byteCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  registerType(): RegisterType {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : RegisterType.UNDEFINED;
  }

  exceptions(): string | null;
  exceptions(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  exceptions(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Nested definitions for this offset (populated on detail endpoints).
   */
  definitions(index: number, obj?: Definition): Definition | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? (obj || new Definition()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  definitionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Nested offset type for this offset (populated on detail endpoints).
   */
  offsetType(obj?: OffsetType): OffsetType | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new OffsetType()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startOffset(builder: flatbuffers.Builder) {
    builder.startObject(15);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addDataBlockId(builder: flatbuffers.Builder, dataBlockIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, dataBlockIdOffset, 0);
  }

  static addOffsetTypeId(builder: flatbuffers.Builder, offsetTypeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, offsetTypeIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, nameOffset, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt32(4, position, 0);
  }

  static addInitialValue(builder: flatbuffers.Builder, initialValue: number) {
    builder.addFieldInt32(5, initialValue, 0);
  }

  static addLastValue(builder: flatbuffers.Builder, lastValue: number) {
    builder.addFieldInt32(6, lastValue, 0);
  }

  static addByteCount(builder: flatbuffers.Builder, byteCount: number) {
    builder.addFieldInt32(7, byteCount, 0);
  }

  static addRegisterType(builder: flatbuffers.Builder, registerType: RegisterType) {
    builder.addFieldInt8(8, registerType, RegisterType.UNDEFINED);
  }

  static addExceptions(builder: flatbuffers.Builder, exceptionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, exceptionsOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, deletedAtOffset, 0);
  }

  static addDefinitions(builder: flatbuffers.Builder, definitionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, definitionsOffset, 0);
  }

  static createDefinitionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDefinitionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOffsetType(builder: flatbuffers.Builder, offsetTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, offsetTypeOffset, 0);
  }

  static endOffset(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): OffsetT {
    return new OffsetT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.dataBlockId() !== null ? this.dataBlockId()!.unpack() : null,
      this.offsetTypeId() !== null ? this.offsetTypeId()!.unpack() : null,
      this.name(),
      this.position(),
      this.initialValue(),
      this.lastValue(),
      this.byteCount(),
      this.registerType(),
      this.exceptions(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<Definition, DefinitionT>(
        this.definitions.bind(this),
        this.definitionsLength(),
      ),
      this.offsetType() !== null ? this.offsetType()!.unpack() : null,
    );
  }

  unpackTo(_o: OffsetT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.dataBlockId = this.dataBlockId() !== null ? this.dataBlockId()!.unpack() : null;
    _o.offsetTypeId = this.offsetTypeId() !== null ? this.offsetTypeId()!.unpack() : null;
    _o.name = this.name();
    _o.position = this.position();
    _o.initialValue = this.initialValue();
    _o.lastValue = this.lastValue();
    _o.byteCount = this.byteCount();
    _o.registerType = this.registerType();
    _o.exceptions = this.exceptions();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.definitions = this.bb!.createObjList<Definition, DefinitionT>(
      this.definitions.bind(this),
      this.definitionsLength(),
    );
    _o.offsetType = this.offsetType() !== null ? this.offsetType()!.unpack() : null;
  }

  unpackFields(...fields: string[]): OffsetT {
    const t = new OffsetT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("data_block_id")) {
      t.dataBlockId = this.dataBlockId() !== null ? this.dataBlockId()!.unpack() : null;
    }
    if (fieldSet.has("offset_type_id")) {
      t.offsetTypeId = this.offsetTypeId() !== null ? this.offsetTypeId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("initial_value")) {
      t.initialValue = this.initialValue();
    }
    if (fieldSet.has("last_value")) {
      t.lastValue = this.lastValue();
    }
    if (fieldSet.has("byte_count")) {
      t.byteCount = this.byteCount();
    }
    if (fieldSet.has("register_type")) {
      t.registerType = this.registerType();
    }
    if (fieldSet.has("exceptions")) {
      t.exceptions = this.exceptions();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("definitions")) {
      t.definitions = this.bb!.createObjList<Definition, DefinitionT>(
        this.definitions.bind(this),
        this.definitionsLength(),
      );
    }
    if (fieldSet.has("offset_type")) {
      t.offsetType = this.offsetType() !== null ? this.offsetType()!.unpack() : null;
    }
    return t;
  }
}

export class OffsetT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public dataBlockId: UuidT | null = null,
    public offsetTypeId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public position: number = 0,
    public initialValue: number = 0,
    public lastValue: number = 0,
    public byteCount: number = 0,
    public registerType: RegisterType = RegisterType.UNDEFINED,
    public exceptions: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public definitions: DefinitionT[] = [],
    public offsetType: OffsetTypeT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const dataBlockId = this.dataBlockId !== null ? this.dataBlockId!.pack(builder) : 0;
    const offsetTypeId = this.offsetTypeId !== null ? this.offsetTypeId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const exceptions = this.exceptions !== null ? builder.createString(this.exceptions!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const definitions = Offset.createDefinitionsVector(
      builder,
      builder.createObjectOffsetList(this.definitions),
    );
    const offsetType = this.offsetType !== null ? this.offsetType!.pack(builder) : 0;

    Offset.startOffset(builder);
    Offset.addId(builder, id);
    Offset.addDataBlockId(builder, dataBlockId);
    Offset.addOffsetTypeId(builder, offsetTypeId);
    Offset.addName(builder, name);
    Offset.addPosition(builder, this.position);
    Offset.addInitialValue(builder, this.initialValue);
    Offset.addLastValue(builder, this.lastValue);
    Offset.addByteCount(builder, this.byteCount);
    Offset.addRegisterType(builder, this.registerType);
    Offset.addExceptions(builder, exceptions);
    Offset.addCreatedAt(builder, createdAt);
    Offset.addUpdatedAt(builder, updatedAt);
    Offset.addDeletedAt(builder, deletedAt);
    Offset.addDefinitions(builder, definitions);
    Offset.addOffsetType(builder, offsetType);

    return Offset.endOffset(builder);
  }

  clone(): OffsetT {
    const obj = new OffsetT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.dataBlockId = this.dataBlockId !== null ? this.dataBlockId!.clone() : null;
    obj.offsetTypeId = this.offsetTypeId !== null ? this.offsetTypeId!.clone() : null;
    obj.name = this.name;
    obj.position = this.position;
    obj.initialValue = this.initialValue;
    obj.lastValue = this.lastValue;
    obj.byteCount = this.byteCount;
    obj.registerType = this.registerType;
    obj.exceptions = this.exceptions;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.definitions = this.definitions.map((e) => e.clone());
    obj.offsetType = this.offsetType !== null ? this.offsetType!.clone() : null;
    return obj;
  }

  equals(other: OffsetT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.dataBlockId !== null && other.dataBlockId !== null) {
      if (!this.dataBlockId!.equals(other.dataBlockId!)) return false;
    } else if (this.dataBlockId !== other.dataBlockId) return false;
    if (this.offsetTypeId !== null && other.offsetTypeId !== null) {
      if (!this.offsetTypeId!.equals(other.offsetTypeId!)) return false;
    } else if (this.offsetTypeId !== other.offsetTypeId) return false;
    if (this.name !== other.name) return false;
    if (this.position !== other.position) return false;
    if (this.initialValue !== other.initialValue) return false;
    if (this.lastValue !== other.lastValue) return false;
    if (this.byteCount !== other.byteCount) return false;
    if (this.registerType !== other.registerType) return false;
    if (this.exceptions !== other.exceptions) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.definitions.length !== other.definitions.length) return false;
    for (let i = 0; i < this.definitions.length; i++) {
      const a = this.definitions[i];
      const b = other.definitions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.offsetType !== null && other.offsetType !== null) {
      if (!this.offsetType!.equals(other.offsetType!)) return false;
    } else if (this.offsetType !== other.offsetType) return false;
    return true;
  }
}

export function verifyOffset(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDefinition);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 32);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyOffsetType(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
